/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Calendar_Not_ConnectedInputs */

const cs_settings_calendar_not_connected = /** @type {(inputs: Settings_Calendar_Not_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nepřipojeno`)
};

const en_settings_calendar_not_connected = /** @type {(inputs: Settings_Calendar_Not_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not connected`)
};

/**
* | output |
* | --- |
* | "Not connected" |
*
* @param {Settings_Calendar_Not_ConnectedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_calendar_not_connected = /** @type {((inputs?: Settings_Calendar_Not_ConnectedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Calendar_Not_ConnectedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_calendar_not_connected(inputs)
	return cs_settings_calendar_not_connected(inputs)
});